import { useFormikContext } from 'formik';
import { Dispatch, memo, SetStateAction, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { ResourceType } from '../../../../../backend';
import { ResourcesPageFormValues } from '../../../../pages/ResourcesPage';
import { LineContainer } from './LineContainer/LineContainer';
import { StyledBox } from './ResourceFieldsLineContainer.style';

export const ResourceFieldsLineContainer = memo(function ResourceFieldsLineContainer({
    resourceType,
    search,
    arrayReplace,
    arrayRemove,
    selectedResources,
    setSelectedResources,
}: {
    resourceType: ResourceType;
    search: string;
    arrayReplace: (index: number, value: any) => void;
    arrayRemove: (index: number) => void;
    selectedResources: number[];
    setSelectedResources: Dispatch<SetStateAction<number[]>>;
}) {
    const { values } = useFormikContext<ResourcesPageFormValues>();

    const filteredElements = useMemo(
        () => values.resources?.filter(r => r.name.startsWith(search)),
        [search, values.resources],
    );

    if (!filteredElements) return null;

    return filteredElements.length === 0 ? (
        <StyledBox p={5} color={'white'} fontSize={'24px'} fontWeight={'400'}>
            <FormattedMessage id={'resourcesForm.noOptions'} />
        </StyledBox>
    ) : (
        <StyledBox>
            {filteredElements.map(resource => (
                <LineContainer
                    arrayRemove={arrayRemove}
                    arrayReplace={arrayReplace}
                    key={values.resources.indexOf(resource)}
                    resourceType={resourceType}
                    index={values.resources.indexOf(resource)}
                    selectedResources={selectedResources}
                    setSelectedResources={setSelectedResources}
                />
            ))}
        </StyledBox>
    );
});
